import { BffDashboard } from "product-test-types";

import { STRAPI_URL } from "../env";

export async function fetchDashboard(): Promise<BffDashboard | undefined> {
  try {
    const response = await fetch(`${STRAPI_URL}/bff-dashboard`, {
      credentials: "include",
    });

    if (response.status >= 400) {
      throw new Error(`Fetch failed with status ${response.status}.`);
    }

    const json = (await response.json()) as BffDashboard;

    return json;
  } catch {
    return;
  }
}

export async function updateManagementSummary(
  managementSummary: string
): Promise<void> {
  const response = await fetch(
    `${STRAPI_URL}/bff-dashboard/management-summary`,
    {
      method: "PATCH",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ managementSummary }),
    }
  );

  if (response.status >= 400) {
    throw new Error(`Fetch failed with status ${response.status}.`);
  }
}
